var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-wrapper pad0"},[_c('event-grid',{attrs:{"slim":true,"height":251,"tableData":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }